import styled from 'styled-components';

const MultiPlatformIconStyled = styled.div``;

export { MultiPlatformIconStyled };
